import React from "react";
import { Dialog, DialogProps } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { useCloseOnBack } from "../hooks/useCloseOnBack";

const basePaperSx: SxProps<Theme> = {
  maxHeight: "calc(100dvh - 24px)",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

const toSxArray = (sx: SxProps<Theme> | undefined) =>
  Array.isArray(sx) ? sx : sx ? [sx] : [];

const AppDialog: React.FC<DialogProps> = ({
  PaperProps,
  scroll = "paper",
  open,
  onClose,
  ...props
}) => {
  useCloseOnBack(
    Boolean(open),
    onClose ? () => onClose({} as object, "escapeKeyDown") : undefined
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll={scroll}
      PaperProps={{
        ...PaperProps,
        sx: [basePaperSx, ...toSxArray(PaperProps?.sx)],
      }}
      {...props}
    />
  );
};

export default AppDialog;
